import {useEffect} from "react";
import {useLocation} from "react-router-dom";

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-VL4KNFRSMQ", {page_path: location.pathname});
  }, [location.pathname]);
}
